<div class="add-field-container">
  <div class="list">
    @for (field of fieldsSettings; track field) {
      <app-checkbox [(ngModel)]="field.checked">
        {{ field.title }}
      </app-checkbox>
    }
  </div>
  <div class="buttons">
    <app-button (click)="save()">{{ 'save' | translate }}</app-button>
    <app-button btnType="cancel" (click)="cancel()">
      {{ 'cancel' | translate }}
    </app-button>
  </div>
</div>
